import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const GoBackButton = ({ onClick }) => (
  <Button onClick={onClick} className="w-16 mb-6" variant="outline">
    <ChevronLeft />
  </Button>
);

export default GoBackButton;
